import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ReactSortable } from "react-sortablejs";
import Department from './Department';
import { updateDepartments } from '../../actions/department';


const ManageCategories = (props) => {

    const [departments, setDepartments] = useState([]);
    const newDepts = useSelector(state => state.departments);

    const dispatch = useDispatch();

    useEffect(() => {

        if (newDepts && newDepts.length > 0) {
            setDepartments(newDepts);
        }

    }, [newDepts]);

    const setDepartmentList = (list) => {
        list.forEach(function (category, index) {
            category.index = index;
        })
        setDepartments(list);
    }

    const setCategories = (slug, categories) => {
        categories.forEach(function (category, index) {
            category.index = index;
        });
        let index = departments.findIndex(x => x.slug === slug);
        let newDepartments = departments;
        departments[index].categories = categories;

        setDepartments(newDepartments);
    }

    const update = () => {
        dispatch(updateDepartments(departments));
        props.onHide();
    }
    const hideParent = () => {
        props.onHide();
    }

    return (

        <Modal show={props.show} onHide={props.onHide} id="categories-modal">

            <React.Fragment>
                <Modal.Header closeButton>
                    <Modal.Title>Manage Departments</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <ReactSortable list={departments} setList={setDepartmentList}>
                                {departments.sort((a, b) => a.index - b.index).map((item, key) => (
                                    <Department item={item} key={key} setCategories={setCategories} hideParent={hideParent} />
                                ))}
                            </ReactSortable>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={update}>
                        Update
					</Button>
                </Modal.Footer>

            </React.Fragment>
        </Modal>
    );
}

export default ManageCategories;
